import PropTypes from 'prop-types';
import React from 'react';
import { Statistics } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function StatisticsVariation({ total = 0, variationUp = 0, variationUnit = null, variationLabel = '', eventStatus, eventEndDate }) {
    const { t } = useTranslation();

    const percentageVariation = React.useMemo(() => {
        // we dont need variationDown any more cause in total deleted element are not included
        const variation = variationUp;
        if (total - variation === 0) {
            return null;
        }
        return +((variation / (total - variation)) * 100).toFixed(0);
    }, [total, variationUp]);

    if (percentageVariation === null || eventStatus === 'closed') {
        return null;
    }

    //Not display variation if (now > endDate + 7 days)
    if (eventStatus === 'over' && eventEndDate) {
        let tmpEndDate = new Date(eventEndDate);
        tmpEndDate.setUTCDate(tmpEndDate.getUTCDate() + 7);
        if (new Date() > tmpEndDate) {
            return null;
        }
    }

    if (percentageVariation > 200) {
        return <div style={{ color: '#39c433' }}>{t('ticket.eventDashboard.hardHightEvolution')}</div>;
    }

    if (percentageVariation < -200) {
        return <div style={{ color: '#df3838' }}>{t('ticket.eventDashboard.hardLowEvolution')}</div>;
    }

    return (
        <Statistics.Variation
            variation={percentageVariation}
            variationUnit={variationUnit}
            variationLabel={percentageVariation === 0 ? t('ticket.eventDashboard.noEvolution') : variationLabel}
        />
    );
}

StatisticsVariation.propTypes = {
    total: PropTypes.string,
    variationUp: PropTypes.string,
    variationUnit: PropTypes.string,
    variationLabel: PropTypes.string,
    eventStatus: PropTypes.string.isRequired,
    eventEndDate: PropTypes.string
};
